<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform" xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
    <div>
        <v-data-table :headers="headers" :items="user_means_paiements"
                      :search="search" sort-by="name" class="elevation-1"
                      :loading="user_means_paiements==undefined" loading-text="Chargement en cours...">
            <template v-slot:item._means_paiement._file="{item}">
                <a v-if="item._means_paiement._file" href="javascript:void(0)"
                   @click="showImage('/'+item._means_paiement._file,item._name,'img')" >
                    <v-img
                            :lazy-src="item._means_paiement._file"
                            max-height="50"
                            max-width="70"
                            :src="item._means_paiement._file"
                    ></v-img>
                </a>
            </template>


            <template v-slot:item._account_name="{item}">
                {{item._account_name}} {{item._account_surname}}
            </template>

            <template v-slot:item._type="{ item }">
                <v-chip :color="getColor(item._type)" dark>{{ item._type }}</v-chip>
            </template>
            <template v-slot:item._created_at="{ item }">
                {{getDate(item._created_at)}}
            </template>

            <template v-slot:item.actions="{ item }" >
                <div style="text-align:  right">
                    <v-menu
                            key="text"
                            rounded="b-xl">
                        <template v-slot:activator="{ attrs, on }">

                            <v-icon

                                    class="black--text "
                                    v-bind="attrs"
                                    v-on="on">mdi-dots-vertical</v-icon>

                        </template>
                        <v-list>
                            <v-list-item
                                    v-for="(action_item, index) in actions_items"
                                    :key="index"
                                    link
                                    @click="editItemAction(item,index)">
                                <v-list-item-icon>
                                    <v-icon color="#29B3A6">{{action_item.avatar}}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title v-text="action_item.title"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </template>

            <template v-slot:no-data>
                {{$t('no_data')}}
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import helpers from '../../../../mixins/helpers'

    export default {
        name: "usermeanspaiement",
        mixins:[helpers(this)],
        props:['headers','user_means_paiements','search','actions_items','editItem','deleteItem'],
        methods:{
            editItemAction(item,index) {
                switch (index){
                    case 0:
                        this.editItem(item);
                        break;
                    case 1:
                        this.deleteItem(item);
                        break;
                }
            },
        }
    }
</script>

<style scoped>

</style>